import { useEffect } from "react";

// Parts of a page marked with the class cf-reveal fade up the first time
// they scroll into view. Pass something that changes when more of them are
// added to the page later (for example the number of events once they load).
const useReveal = (watch) => {
    useEffect(() => {
        const items = Array.from(document.querySelectorAll(".cf-reveal:not(.is-in)"));

        if (!("IntersectionObserver" in window)) {
            items.forEach((item) => item.classList.add("is-in"));
            return undefined;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-in");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12 });

        items.forEach((item) => observer.observe(item));

        return () => observer.disconnect();
    }, [watch]);
};

export default useReveal;
